import { Component, Directive, ElementRef, inject, Injector, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UpgradeComponent } from '@angular/upgrade/static';

@Directive({
  selector: 'user-view-directive',
  standalone: false
})
export class UserViewDirective extends UpgradeComponent {
  @Input() user: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('userViewComponent', elementRef, injector);
  }
}

@Component({
  selector: 'user-view-component',
  template: '<user-view-directive [user]="user"></user-view-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserViewComponent {
  @Input() user: string;

  private route = inject(ActivatedRoute);

  constructor() {
    this.route.params.subscribe(params => {
      this.user = params['user'];
    });
  }
}

@Directive({
  selector: 'user-edit-directive',
  standalone: false
})
export class UserEditDirective extends UpgradeComponent {
  @Input() user: string;
  @Input() goTo: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('userEditComponent', elementRef, injector);
  }
}

@Component({
  selector: 'user-edit-component',
  template: '<user-edit-directive [user]="user" [goTo]="goTo"></user-edit-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserEditComponent {
  @Input() user: string;
  @Input() goTo: string;

  private route = inject(ActivatedRoute);

  constructor() {
    this.route.params.subscribe(params => {
      this.user = params['user'];
      this.goTo = params['goTo'];
    });
  }
}

@Directive({
  selector: 'users-list-directive',
  standalone: false
})
export class UsersListDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('usersListComponent', elementRef, injector);
  }
}

@Component({
  selector: 'users-list-component',
  template: '<users-list-directive></users-list-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UsersListComponent {}

@Directive({
  selector: 'user-create-directive',
  standalone: false
})
export class UserCreateDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('userCreateComponent', elementRef, injector);
  }
}

@Component({
  selector: 'user-create-component',
  template: '<user-create-directive></user-create-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserCreateComponent {}

@Directive({
  selector: 'user-events-directive',
  standalone: false
})
export class UserEventsDirective extends UpgradeComponent {
  @Input() user: string;
  @Input() filterId: string;

  constructor(elementRef: ElementRef, injector: Injector) {
    super('userEvents', elementRef, injector);
  }
}

@Component({
  selector: 'user-events-component',
  template: '<user-events-directive [user]="user" [filterId]="filterId"></user-events-directive>',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserEventsComponent {
  @Input() user: string;
  @Input() filterId: string;
}

// @Directive({
//   selector: 'user-goals-directive',
//   standalone: false
// })
// export class UserGoalsDirective extends UpgradeComponent {
//   @Input() user: string;
//   @Input() filterId: string;

//   constructor(elementRef: ElementRef, injector: Injector) {
//     super('userGoals', elementRef, injector);
//   }
// }

// @Component({
//   selector: 'user-goals-component',
//   template: '<user-goals-directive [user]="user" [filterId]="filterId"></user-goals-directive>',
//   standalone: false
// })
// export class UserGoalsComponent {
//   @Input() user: string;
//   @Input() filterId: string;

//   private route = inject(ActivatedRoute);

//   constructor() {
//     this.route.params.subscribe(params => {
//       this.user = params['user'];
//       this.filterId = params['filterId'];
//     });
//   }
// }

// // Add more directives and components as needed for the migration
